<template>
  <div class="container input-container py-3">
    <h3 class="text-center">Component</h3>
    <div class="d-flex justify-content-center">
      <vp-input
        :isLoading="isLoading"
        :disabled="disabled"
        :required="required"
        v-model="inputModel"
        :label="label"
        :errMsg="errMsg"
        :invalid="invalid"
        :placeholder="placeholder"
        :maxlength="maxlength"
        :width="width"
      />
    </div>
    <div class="text-center mt-2 vp-color-black-1 vp-mb-20">
      v-model : {{ inputModel }}
    </div>

    <div class="col-container">
      <div class="vp-col vp-border-black-1-2 rounded">
        <h5 class="vp-font-weight-700">#General props</h5>

        <div class="form-group row">
          <label class="col-sm-4 col-form-label">width ({{ width }}px)</label>
          <div class="vp-ml-15 vp-width-200">
            <b-form-input
              id="range-1"
              v-model="width"
              type="range"
              min="200"
              max="700"
            />
          </div>
        </div>

        <div class="form-group row">
          <label class="col-sm-4 col-form-label">label</label>
          <div class="col-sm-8">
            <input
              class="form-control vp-width-200"
              v-model="label"
              placeholder="Title.."
            />
          </div>
        </div>

        <div class="form-group row">
          <label class="col-sm-4 col-form-label">placeholder</label>
          <div class="col-sm-8">
            <input
              class="form-control vp-width-200"
              v-model="placeholder"
              placeholder="Placeholder.."
            />
          </div>
        </div>

        <div class="form-group row">
          <label class="col-sm-4 col-form-label">maxlength</label>
          <div class="col-sm-8">
            <input
              class="form-control vp-width-200"
              v-model="maxlength"
              placeholder="Maxlength"
              type="number"
            />
          </div>
        </div>

        <div class="form-group row">
          <label class="col-sm-4 col-form-label">errMsg</label>
          <div class="col-sm-8">
            <input
              class="form-control vp-width-200"
              v-model="errMsg"
              placeholder="There is an error .."
            />
          </div>
        </div>

        <div class="form-group row">
          <label class="col-sm-4 col-form-label">invalid</label>
          <div class="col-sm-8 vp-mt-minus-8">
            <vp-switch v-model="invalid" />
          </div>
        </div>

        <div class="form-group row">
          <label class="col-sm-4 col-form-label">disabled</label>
          <div class="col-sm-8 vp-mt-minus-8">
            <vp-switch v-model="disabled" />
          </div>
        </div>

        <div class="form-group row">
          <label class="col-sm-4 col-form-label">isLoading</label>
          <div class="col-sm-8 vp-mt-minus-8">
            <vp-switch v-model="isLoading" />
          </div>
        </div>

        <div class="form-group row">
          <label class="col-sm-4 col-form-label">required</label>
          <div class="col-sm-8 vp-mt-minus-8">
            <vp-switch v-model="required" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      disabled: false,
      isLoading: false,
      required: false,
      inputModel: null,
      inputModel_2:null,
      label: "",
      errMsg: "",
      placeholder: "",
      maxlength: "",
      width: "350",
      invalid: false,
    };
  },
};
</script>

<style lang="scss">
.input-container {
  .col-container {
    display: table;
    width: 110%;
    border-spacing: 3px;
    margin-inline-start: -25px;
  }

  .vp-col {
    display: table-cell;
    padding: 5px;
  }
}
</style>
